import ApiService from './api.service'

const Pow450SmService = {

  /***
   * Get current connected color code
   * @param {string} params.ip customer id of the customer to find
   * @param {string} params.updateConfig flag to update the CC/latest contact time
   * @returns {*}
   */
  getCurrentCC (params) {
    return ApiService.query('pow-450-sm/get-cc', params)
  },
  /***
   * Get array of radio stats
   * @param {string} params.ip customer id of the customer to find
   * @param {string} params.updateConfig flag to update the CC/latest contact time
   * @returns {*}
   */
  getCurrentStats (params) {
    return ApiService.query('pow-450-sm/get-stats', params)
  },
  /***
   * Trigger radio config import
   * @param {string} params.ip radio ip address we want to trigger import for
   * @returns {*}
   */
  triggerConfigImport (params) {
    return ApiService.post('pow-450-sm/trigger-conf-import', params)
  },
  /***
   * Trigger radio reboot
   * @param {string} params.ip radio ip address we want to trigger import for
   * @returns {*}
   */
  triggerReboot (params) {
    return ApiService.post('pow-450-sm/trigger-reboot', params)
  },
}
export default Pow450SmService
